import * as yup from 'yup';

import firstPartyDataSchema from '@components/OnboardingModal/ProfileFields/FirstPartyDataSchema';

export const nameSchema = yup
  .string()
  .max(255, 'Name cannot be longer than 255 characters')
  .test('validate name', 'Please enter a full name', (value) => {
    return /^[^ ]+( [^ ]+)+$/.test(value?.trim());
  })
  .required('Please enter a full name');

const schema = () =>
  yup.object().shape({
    email: yup.string().email().required('Please enter a valid email'),
    name: nameSchema,
    password: yup.string().min(6, 'Minimum password is 6 character').nullable(),
    passwordConfirmation: yup
      .string()
      .test('passwords-match', 'Passwords must match', function (value) {
        return this.parent.password === value;
      }),
    ...firstPartyDataSchema({ isRequired: false }),
  });

export default schema;
